import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

import { JollyRancherChip } from "veneer/Chip";
import Stack from "veneer/Stack";

import { Tag } from "./model";

interface DeviceTagsProps {
  emptyValue?: ReactNode;
  hideSystemTags?: boolean;
  tags: ReadonlyArray<Tag>;
  tagsUrlRoot?: string;
}

function sort(tags: ReadonlyArray<Tag>) {
  if (tags) {
    return [...tags].sort((first, second) => {
      const fname = first.name;
      const sname = second.name;
      // System tags should be ordered first.
      const fsys = fname && fname[0] === "_";
      const ssys = sname && sname[0] === "_";
      if (fsys && !ssys) {
        return -1;
      } else if (!fsys && ssys) {
        return 1;
      }
      return fname.localeCompare(sname);
    });
  }
  return tags;
}

function DeviceTags({
  emptyValue,
  hideSystemTags,
  tags = [],
}: DeviceTagsProps) {
  const sortedTags = sort(tags);
  const visibleTags = hideSystemTags
    ? sortedTags.filter((tag) => tag.name[0] !== "_")
    : sortedTags;

  return (
    <Stack direction="row" flexWrap="wrap" spacing={1}>
      {visibleTags.length
        ? visibleTags.map((tag) => <DeviceTag key={tag.id} tag={tag} />)
        : emptyValue}
    </Stack>
  );
}

function DeviceTag({ tag }: { tag: Tag }) {
  const color = tag.name[0] === "_" ? "teal" : "purple";

  return (
    <Link
      to={{
        pathname: "/devices",
        state: { tag: String(tag.id) },
      }}
    >
      <JollyRancherChip color={color} label={tag.name} />
    </Link>
  );
}

export { DeviceTag, DeviceTags };
export default DeviceTags;
